<script>
	export let error = ''
</script>

{#if error}
	<span class="error">{error}</span>
{/if}

<style lang="scss">
	.error {
		display: block;
		font-size: 12px;
		color: #c94848;
		margin: 10px 0 18px;
	}
</style>
